export default "__VITE_ASSET__BGxT51Ic__"